export const setFulfillableOrders = (orders) => {
    return {
        type: "SET_FULFILLABLE_ORDERS",
        payload: orders
    }
};
